var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { Icon } from '../Icon/index.js';
import { NavVerticalContext, useNavVerticalContext, } from './NavVerticalContext.js';
export const NavVertical = (props) => {
    const { as, children, className, collapsed = false, size = 'md' } = props, rest = __rest(props, ["as", "children", "className", "collapsed", "size"]);
    const Component = as || 'nav';
    return (React.createElement(Component, Object.assign({ className: twMerge(clsx('flex flex-col space-y-8 isolate', collapsed ? 'items-center' : 'w-full', className)), "aria-label": "Sidebar" }, rest),
        React.createElement(NavVerticalContext.Provider, { value: { collapsed, size } }, children)));
};
const NavVerticalItem = props => {
    const { children, as, leadingIcon, trailingIcon, active = false, className } = props, rest = __rest(props, ["children", "as", "leadingIcon", "trailingIcon", "active", "className"]);
    const Component = as || 'a';
    const { collapsed, size } = useNavVerticalContext();
    const paddingClsx = [
        size === 'md' && ' px-3 py-2',
        size === 'lg' && ' px-4 py-4',
    ];
    const content = typeof children === 'string' ? (React.createElement("span", { className: "flex-grow truncate" }, children)) : (children);
    if (!leadingIcon && collapsed) {
        console.warn('leading icon is required when using collapsed');
    }
    return (React.createElement(Component, Object.assign({ className: clsx(active
            ? 'bg-main-200 text-basicMain-900'
            : 'text-basicMain-600 hover:bg-main-100 hover:text-basicMain-900', 'group flex items-center leading-5 rounded-md', paddingClsx, className), "aria-current": active ? 'page' : undefined }, rest),
        leadingIcon && (React.createElement(Icon, { className: clsx(active
                ? 'text-basicMain-500'
                : 'text-basicMain-400 group-hover:text-basicMain-600', 'flex-shrink-0 h-6 w-6', !collapsed && '-ml-1 mr-3'), "aria-hidden": "true" }, leadingIcon)),
        !collapsed ? content : null,
        !collapsed && trailingIcon && (React.createElement(Icon, { className: clsx(active
                ? 'text-basicMain-500'
                : 'text-basicMain-400 group-hover:text-basicMain-600', 'flex-shrink-0 h-6 w-6 -mr-1 ml-3'), "aria-hidden": "true" }, trailingIcon))));
};
const NavVerticalItemSecondary = props => {
    const { children, leadingIcon, active = false, className } = props, rest = __rest(props, ["children", "leadingIcon", "active", "className"]);
    const { collapsed } = useNavVerticalContext();
    const content = typeof children === 'string' ? (React.createElement("span", { className: "truncate" }, children)) : (children);
    if (!leadingIcon && collapsed) {
        console.warn('leading icon is required when using collapsed');
    }
    return (React.createElement("a", Object.assign({ className: clsx('group flex items-center px-3 py-2 text-basicMain-600 leading-none rounded-md hover:text-basicMain-900 hover:bg-main-100', 'focus:outline-none focus-visible:ring', className), "aria-current": active ? 'page' : undefined }, rest),
        leadingIcon && (React.createElement(Icon, { className: clsx(active
                ? 'text-basicMain-500'
                : 'text-basicMain-400 group-hover:text-basicMain-600', 'flex-shrink-0 h-6 w-6', !collapsed && '-ml-1 mr-3'), "aria-hidden": "true" }, leadingIcon)),
        !collapsed ? content : null));
};
export const NavVerticalGroup = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    const { size } = useNavVerticalContext();
    return (React.createElement("div", Object.assign({ className: clsx(size === 'lg' ? 'space-y-2' : 'space-y-1', className), role: "group" }, rest), children));
};
export const NavVerticalGroupHeader = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return (React.createElement("h3", Object.assign({ className: clsx('px-3 text-sm font-semibold text-basicMain-500 uppercase tracking-wider', className) }, rest), children));
};
NavVertical.Item = NavVerticalItem;
NavVertical.ItemSecondary = NavVerticalItemSecondary;
NavVertical.Group = NavVerticalGroup;
NavVertical.GroupHeader = NavVerticalGroupHeader;
//# sourceMappingURL=NavVertical.js.map